import React, { useState, useEffect } from 'react';
import './passwordReset.css';
import { Col, Row, Form, Button, InputGroup } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { CandidateService } from '../../../services/candidateService';
import { decodeJWT } from '../../../services/candidateService';
import _ from 'lodash';
import { Link, useNavigate } from 'react-router-dom';
import profilebackButtonIcon from '../../../assets/images/Ic_back.png';

const CandidateResetPassword = () => {
    const [showPassword, setShowPassword] = useState({
        current: false,
        new: false,
        confirm: false,
    });

    const [passwords, setPasswords] = useState({
        current: '',
        new: '',
        confirm: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [usernameOrEmail, setUsernameOrEmail] = useState('');
    const navigate = useNavigate();
    useEffect(() => {
        const token = window.localStorage.getItem('authToken');
        if (!token) {
            alert('Not logged in or missing token');
            navigate('/login');
            return;
        }

        const decoded = decodeJWT(token);
        const candidateId = _.get(decoded, 'username', '');
        if (!candidateId) {
            alert('Invalid token');
            navigate('/login');
            return;
        }

        setUsernameOrEmail(candidateId);
    }, [navigate]);

    const togglePassword = (field) => {
        setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
    };

    const handlePasswordChange = (field, value) => {
        setPasswords((prev) => {
            const updated = { ...prev, [field]: value };

            if (
                updated.current &&
                isPasswordValid(updated.new) &&
                updated.new === updated.confirm
            ) {
                setError(null);
            }

            return updated;
        });
    };

    const isPasswordValid = (password) => {
        const lengthOK = password.length >= 8;
        const hasUppercase = /[A-Z]/.test(password);
        const hasDigit = /\d/.test(password);
        const hasSpecial = /[@$&!#]/.test(password);
        return lengthOK && hasUppercase && hasDigit && hasSpecial;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(false);

        if (!passwords.current || !passwords.new || !passwords.confirm) {
            setError('All fields are required.');
            return;
        }
        if (!isPasswordValid(passwords.new)) {
            setError(
                'Password must be at least 8 characters, contain 1 uppercase letter, 1 digit, and 1 special character (@ $ & ! #).'
            );
            return;
        }


        if (passwords.new !== passwords.confirm) {
            setError('New and confirm passwords do not match.');
            return;
        }

        const token = window.localStorage.getItem('authToken');
        if (!token) {
            setError('Missing token');
            return;
        }

        setLoading(true);
        try {
            await CandidateService.candidatePostLoginPasswordReset(
                usernameOrEmail,
                passwords.current,
                passwords.new,
                passwords.confirm,
                token
            );
            setSuccess(true);
            setPasswords({ current: '', new: '', confirm: '' });
        } catch (err) {
            setError(err.response?.data?.message || 'Password reset failed.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="fluid-container candidateResetPassword" style={{ minHeight: '600px' }}>
            {/* Breadcrumb */}
            <div className="profile-candidate-breadcrumb mb-3">
                <div className="breadcrumb-candidate">
                    <Link
                        to={-1}
                        style={{ color: '#99A4AF', textDecoration: 'none' }}
                        state={{ scrollPosition: sessionStorage.getItem("initialScrollPosition") }}
                    >
                        <img src={profilebackButtonIcon} alt="Back" className="profile-breadcrumb-back-icon" />{' '}
                        <span className="profile-breadcrumb-back-text">Back</span>
                    </Link>
                </div>
            </div>
            <div className="password-card-header mb-4">
                <h4>Reset Your Password</h4>
            </div>
            <Row className="justify-content-center">
                <Col xs={12} md={8} lg={6} className="resetpassword-card p-4 shadow-sm bg-white rounded">
                    <div className='password-card-subtitle'>
                        <p>
                            Create a new password with at least 8 characters, including 1 uppercase letter, 1 digit, and 1 special character (@, $, &, !, #).
                        </p>

                    </div>
                    {error && <p className="text-danger">{error}</p>}
                    {success && <p className="text-success">Password has been reset successfully.</p>}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="currentPassword" className="mb-3 candidate-password-fields">
                            <Form.Label>Current Password*</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={showPassword.current ? 'text' : 'password'}
                                    placeholder="Enter current password"
                                    value={passwords.current}
                                    onChange={(e) => handlePasswordChange('current', e.target.value)}
                                />
                                {passwords.current.length > 0 && (
                                    <InputGroup.Text onClick={() => togglePassword('current')} className="password-toggle-icon">
                                        {showPassword.current ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroup.Text>
                                )}
                            </InputGroup>
                        </Form.Group>

                        <Form.Group controlId="newPassword" className="mb-3 candidate-password-fields">
                            <Form.Label>New Password*</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={showPassword.new ? 'text' : 'password'}
                                    placeholder="Enter new password"
                                    value={passwords.new}
                                    onChange={(e) => handlePasswordChange('new', e.target.value)}
                                />
                                {passwords.new.length > 0 && (
                                    <InputGroup.Text onClick={() => togglePassword('new')} className="password-toggle-icon">
                                        {showPassword.new ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroup.Text>
                                )}
                            </InputGroup>
                        </Form.Group>

                        <Form.Group controlId="confirmPassword" className="mb-3 candidate-password-fields">
                            <Form.Label>Confirm Password*</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={showPassword.confirm ? 'text' : 'password'}
                                    placeholder="Re-enter new password"
                                    value={passwords.confirm}
                                    onChange={(e) => handlePasswordChange('confirm', e.target.value)}
                                />
                                {passwords.confirm.length > 0 && (
                                    <InputGroup.Text onClick={() => togglePassword('confirm')} className="password-toggle-icon">
                                        {showPassword.confirm ? <FaEyeSlash /> : <FaEye />}
                                    </InputGroup.Text>
                                )}
                            </InputGroup>
                        </Form.Group>

                        <hr />

                        <div className="text-end">
                            <Button
                                type="submit"
                                className="candidate-resetPassword-button"
                                disabled={loading}
                                style={loading ? { backgroundColor: '#f35824', color: '#FFFFFF' } : {}}
                            >
                                {loading ? 'Resetting...' : 'Reset Password'}
                            </Button>

                        </div>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default CandidateResetPassword;